var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('sidebar.shortTitle'),"title":_vm.$t('sidebar.title')}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.dashboard'),
            img: require('../../assets/img/Overview.png'),
            path: '/dashboard',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.cluster'),
            img: require('../../assets/img/Cluster.png'),
          }}},[_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.listcluster'), path: '/listcluster' }}})],1),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.feederpillar'),
          icon: 'tim-icons icon-image-02' }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.management'),
            img: require('../../assets/img/Admin.png'),
          }}},[(_vm.isAdmin == true)?_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.usermanagement'), path: '/admin/user' }}}):_vm._e(),(
              _vm.isAdmin == true ||
              _vm.isDeviceCreate == true ||
              _vm.isDeviceDelete == true
            )?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.devicemanagement'),
              path: '/admin/device',
            }}}):_vm._e(),(
              _vm.isAdmin == true ||
              _vm.isDeviceCreate == true ||
              _vm.isDeviceDelete == true
            )?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.gatewaymanagement'),
              path: '/admin/gateway',
            }}}):_vm._e(),(
              _vm.isAdmin == true ||
              _vm.isClusterCreate == true ||
              _vm.isClusterDelete == true
            )?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.clustermanagement'),
              path: '/admin/clustermanagement',
            }}}):_vm._e(),(
              _vm.isAdmin == true ||
              _vm.isClusterCreate == true ||
              _vm.isClusterDelete == true
            )?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.feederpillarmanagement'),
              path: '/admin/feederpillar',
            }}}):_vm._e()],1),(
            _vm.isAdmin == true ||
            _vm.isDeviceView == true ||
            _vm.isDeviceDelete == true ||
            _vm.isClusterView == true
          )?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.scheduler'),
            img: require('../../assets/img/Schedule.png'),
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.clusterscheduler'),
              path: '/clusterscheduler',
            }}})],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.operation'),
            img: require('../../assets/img/operator.png'),
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.operationoverview'),
              path: '/operation',
            }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.wo'), path: '/ticketstatus/all' }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.performance'), path: '/performance' }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.report'), path: '/report' }}})],1)],1)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1),_c('modal',{attrs:{"show":_vm.modals.noti,"type":"medium","showClose":false,"centered":_vm.center,"clickToClose":_vm.clickclose},on:{"update:show":function($event){return _vm.$set(_vm.modals, "noti", $event)}}},[_c('template',{slot:"header"},[_c('h3',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_c('i',{staticClass:"tim-icons icon-bell-55 text-success",staticStyle:{"font-size":"20px"}}),_vm._v("\n          New Notification\n        ")])]),_c('div',{staticClass:"text-left"},_vm._l((_vm.wonoti),function(item){return _c('p',{key:item.id,staticClass:"text-left"},[_vm._v(" \n          There is a status change on the work order "+_vm._s(item.woid)+". "),_c('base-button',{staticClass:"btn btn-link",on:{"click":function($event){return _vm.open(item.woid)}}},[_vm._v("Click here to see more.")])],1)}),0)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }